import * as React from 'react'
import injectSheet from 'react-jss'
import {WithClasses} from './Helper'

const styles = {
    root: {
        display: 'flex',
        flexWrap: 'wrap'
    },
}

interface Properties {
    readonly children: React.ReactNode
}

export const ChipWrapper =
    injectSheet(styles)(
        ({classes, children}: WithClasses<Properties>) =>
            <div className={classes.root}>{children}</div>
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/ChipWrapper.tsx